/* eslint-disable internal-rules/no-restricted-design-system-imports */
/* eslint-disable internal-rules/no-restricted-design-system-props */
import type { HTMLAttributes } from 'react';

import { Waypoint } from 'react-waypoint';

import { Separator } from '@change/ds-core-ui';

import { SuggestedPetitionsLazy as SuggestedPetitionsLazySunrise } from 'src/app/shared/components/suggestedPetitionsLazySunrise';

import { usePageFooter } from './hooks/usePageFooter';

export function PageFooter(props: HTMLAttributes<HTMLDivElement>) {
	const {
		data: { petitionId },
		actions: { handleSuggestedPetitionsPosition },
	} = usePageFooter();

	return (
		<div className="pb-8" {...props}>
			<div>
				<Separator orientation="horizontal" className="mb-2 mt-[52px] md:mt-20" />
			</div>
			<Waypoint
				onPositionChange={({ currentPosition }) => handleSuggestedPetitionsPosition(currentPosition === 'below')}
			/>
			<SuggestedPetitionsLazySunrise
				channel="dm_responses"
				sourceLocation="dm_responses"
				petitionSlugOrId={petitionId}
			/>
		</div>
	);
}
